import React, { Component, PropTypes } from 'react';
import { MainColorPicker } from '../../../widgets/index';

const ThemeColorRow = ({ id, label, color, idx, panel, onColorChange, messageType, isDisabled }) => {
    return (
        <div className="ThemeColorRow col-sm-1">
            {messageType[idx]}
            <MainColorPicker color={color} isDisabled={isDisabled} onColorChange={onColorChange(idx, panel, label)} />
        </div>
    );
};

ThemeColorRow.propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
    idx: PropTypes.number,
    id: PropTypes.string,
    panel: PropTypes.string,
    onColorChange: PropTypes.func
};

export default ThemeColorRow;



// WEBPACK FOOTER //
// ./src/components/pages/theme/colors/ColorRow.js